import React, { useState, useEffect } from 'react';
import { Table, Button, Space, Row, Col, Input, message, Popconfirm } from 'antd';
import { 
  DatabaseOutlined, 
  PlusOutlined, 
  DeleteOutlined, 
  EditOutlined,
  EnvironmentOutlined,
  SaveOutlined,
  CloseOutlined,
  SearchOutlined // Dodata ikonica
} from '@ant-design/icons';
import axios from 'axios';

const MobileRegisterMachines = () => {
  const [machines, setMachines] = useState([]);
  const [mappings, setMappings] = useState([]);
  const [allBoxes, setAllBoxes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const [editingMachine, setEditingMachine] = useState(null);
  const [formData, setFormData] = useState({ machine_id: '', name: '' });
  const [searchText, setSearchText] = useState(''); // State za pretragu

  const MACHINES_URL = '/api/box/machines-api/';
  const MAPPINGS_URL = '/api/box/mappings-api/';
  const BOX_LIST_URL = '/api/box/list/';

  const fetchData = async () => {
    setLoading(true);
    try {
      const [resMachines, resMappings, resBoxes] = await Promise.all([
        axios.get(MACHINES_URL),
        axios.get(MAPPINGS_URL),
        axios.get(BOX_LIST_URL)
      ]);
      setMachines(resMachines.data);
      setMappings(resMappings.data);
      setAllBoxes(resBoxes.data);
    } catch (error) {
      message.error('Error loading data');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Logika za filtriranje (traži po ID-u ili Modelu)
  const filteredMachines = machines.filter(m => {
    const search = searchText.toLowerCase();
    return (
      (m.machine_id || '').toString().toLowerCase().includes(search) ||
      (m.name || '').toLowerCase().includes(search)
    );
  });

  const openOverlay = (machine = null) => {
    if (machine) {
      setEditingMachine(machine);
      setFormData({ machine_id: machine.machine_id, name: machine.name });
    } else {
      setEditingMachine(null);
      setFormData({ machine_id: '', name: '' });
    }
    setIsOverlayOpen(true);
  };

  const handleSave = async () => {
    if (!formData.machine_id || !formData.name) {
      message.warning('All fields are required');
      return;
    }
    try {
      if (editingMachine) {
        await axios.put(`${MACHINES_URL}${editingMachine.id}/`, formData);
        message.success('Machine updated');
      } else {
        await axios.post(MACHINES_URL, formData);
        message.success('Machine added');
      }
      setIsOverlayOpen(false);
      fetchData();
    } catch (error) {
      message.error('Error saving machine');
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${MACHINES_URL}${id}/`);
      message.success('Machine removed');
      fetchData();
    } catch (error) {
      message.error('Error deleting machine');
    }
  };

  const columns = [
    {
      title: 'Machine List',
      key: 'machine_card',
      render: (record) => {
        const mapping = mappings.find(m => m.machine === record.id || m.machine === record.machine_id);
        const boxDetail = mapping ? allBoxes.find(b => b.id === mapping.box || b.box_id === mapping.box_id) : null;

        return (
          <div className="m-mini-card">
            <div className="m-card-col main-info">
              <div className="m-box-top">
                <div className="m-inv-id" onClick={() => openOverlay(record)}>{record.machine_id}</div>
              </div>
              <div className="loc-text">
                <EnvironmentOutlined style={{ fontSize: '10px' }} /> {boxDetail ? boxDetail.box_name : mapping?.box_name || 'In Stock'}
              </div>
            </div>

            <div className="m-card-col seen-info">
              <div className="m-inv-model">{record.name}</div>
              <div className="box-id-text">Box: {boxDetail ? boxDetail.box_id : mapping?.box_id || '-'}</div>
            </div>

            <div className="m-card-col action-btn">
              <div className="m-pl-actions">
                <Button 
                  size="middle" 
                  icon={<EditOutlined />} 
                  onClick={() => openOverlay(record)} 
                  className="view-btn-dark edit-style"
                />
                <Popconfirm title="Delete?" onConfirm={() => handleDelete(record.id)}>
                  <Button 
                    size="middle" 
                    icon={<DeleteOutlined />} 
                    className="view-btn-dark del-style"
                  />
                </Popconfirm>
              </div>
            </div>
          </div>
        );
      }
    }
  ];

  return (
    <div className="mobile-dashboard-wrapper">
      <Row gutter={[8, 8]} style={{ marginBottom: '15px' }}>
        <Col span={12}>
          <div className="st-box" style={{ borderBottomColor: '#3b82f6', height: '40px' }}>
            <Space>
              <DatabaseOutlined style={{ color: '#3b82f6', fontSize: '18px' }} />
              <span style={{ color: 'white', fontWeight: 'bold', fontSize: '16px' }}>{machines.length}</span>
            </Space>
          </div>
        </Col>
        <Col span={12}>
          <div className="st-box" style={{ borderBottomColor: '#34d399', cursor: 'pointer', height: '40px' }} onClick={() => openOverlay()}>
            <Space>
              <PlusOutlined style={{ color: '#34d399', fontSize: '18px' }} />
              <span style={{ color: 'white', fontWeight: 'bold', fontSize: '13px' }}>ADD</span>
            </Space>
          </div>
        </Col>
      </Row>

      {/* SEARCH POLJE */}
      <div style={{ marginBottom: '15px' }}>
        <Input
          placeholder="Pretraži mašine (ID ili Model)..."
          prefix={<SearchOutlined style={{ color: '#94a3b8' }} />}
          onChange={e => setSearchText(e.target.value)}
          className="m-search-input"
          allowClear
        />
      </div>

      <Table 
        dataSource={filteredMachines} 
        columns={columns} 
        rowKey="id" 
        loading={loading} 
        pagination={false} 
        className="m-inv-table" 
      />

      {isOverlayOpen && (
        <div className="m-custom-overlay">
          <div className="m-overlay-content">
            <div className="m-overlay-header">
              <span>{editingMachine ? 'EDIT' : 'ADD NEW'}</span>
              <Button type="text" icon={<CloseOutlined style={{ color: 'white' }} />} onClick={() => setIsOverlayOpen(false)} />
            </div>
            <div className="m-overlay-body">
              <div style={{ marginBottom: '10px' }}>
                <label style={{ color: '#64748b', fontSize: '10px', display: 'block', marginBottom: '3px' }}>MACHINE ID</label>
                <Input value={formData.machine_id} onChange={e => setFormData({...formData, machine_id: e.target.value})} style={{ background: '#0f172a', color: 'white', border: '1px solid #334155' }} />
              </div>
              <div style={{ marginBottom: '15px' }}>
                <label style={{ color: '#64748b', fontSize: '10px', display: 'block', marginBottom: '3px' }}>MODEL</label>
                <Input value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} style={{ background: '#0f172a', color: 'white', border: '1px solid #334155' }} />
              </div>
              <Button block type="primary" icon={<SaveOutlined />} onClick={handleSave} style={{ background: '#3b82f6', height: '45px', fontWeight: 'bold' }}>SAVE</Button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .mobile-dashboard-wrapper { padding-bottom: 20px; }
        .st-box { background: #1e293b; border-radius: 8px; border: 1px solid #334155; border-bottom: 4px solid; display: flex; justify-content: center; align-items: center; }
        
        /* SEARCH STIL */
        .m-search-input {
          background: #1e293b !important;
          border: 1px solid #334155 !important;
          color: white !important;
          border-radius: 8px !important;
          height: 45px !important;
        }
        .m-search-input input {
          background: transparent !important;
          color: white !important;
        }
        .m-search-input .ant-input-clear-icon { color: #94a3b8 !important; }

        .m-inv-table .ant-table { background: transparent !important; }
        .m-inv-table .ant-table-thead { display: none !important; }
        .m-inv-table .ant-table-tbody > tr > td { border: none !important; padding: 0 0 10px 0 !important; background: transparent !important; }

        .m-mini-card { 
          background: #1e293b; 
          border: 1px solid #475569; 
          border-radius: 10px; 
          padding: 12px; 
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 8px;
        }

        .m-card-col { display: flex; flex-direction: column; min-width: 0; }
        .main-info { flex: 1.2; }
        .seen-info { flex: 1.5; }
        .action-btn { flex: 0 0 auto; }

        .m-box-top { display: flex; align-items: center; gap: 8px; }
        .m-inv-id { color: #3b82f6 !important; font-weight: 800; font-size: 16px; text-decoration: underline; cursor: pointer; line-height: 1.1; }
        .loc-text { color: #34d399; font-size: 11px; font-weight: 600; margin-top: 4px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

        .m-inv-model { color: white; font-weight: 700; font-size: 13px; line-height: 1.1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .box-id-text { color: #94a3b8; font-size: 10px; margin-top: 2px; }

        .m-pl-actions { display: flex; gap: 6px; }

        .view-btn-dark {
          background: #1e293b !important; 
          color: #94a3b8 !important; 
          border: 1px solid #334155 !important; 
          border-radius: 6px !important; 
          font-weight: bold !important; 
          height: 34px !important;
          width: 34px !important;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 !important;
        }
        .edit-style { color: #60a5fa !important; }
        .del-style { color: #ef4444 !important; }

        .m-custom-overlay { position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(0,0,0,0.85); z-index: 9999; display: flex; align-items: center; justify-content: center; }
        .m-overlay-content { background: #1e293b; width: 85%; max-width: 350px; border-radius: 12px; border: 1px solid #334155; }
        .m-overlay-header { padding: 15px; border-bottom: 1px solid #334155; display: flex; justify-content: space-between; align-items: center; color: white; font-size: 14px; font-weight: bold; }
        .m-overlay-body { padding: 20px; }
      `}</style>
    </div>
  );
};

export default MobileRegisterMachines;